import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modificar-paquete',
  templateUrl: './modificar-paquete.component.html',
  styleUrls: ['./modificar-paquete.component.css']
})
export class ModificarPaqueteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
